module.exports = __webpack_public_path__ + "static/img/league_building_02.9cc05c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/league_building_02.png
// module id = 6rZs
// module chunks = 0